import { CommonModule } from '@angular/common';
import { Component, inject, Input } from '@angular/core';
import { ButtonModule } from '@coreui/angular';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'smarsh-app-session-dialog',
  standalone: true,
  imports: [CommonModule, ButtonModule],
  templateUrl: './app-session-dialog.component.html',
  styles: ''
})
export class AppSessionDialogComponent {
  activeModal = inject(NgbActiveModal);

  @Input() title: string = 'Confirm';
  @Input() baseMessage: string;

  @Input() saveButtonLabel: string = 'Confirm';
  @Input() cancelButtonLabel: string = 'Cancel';

  @Input() sessionExpired: boolean = false;
  @Input() countdown: number = 0;

  closeModel() {
    this.activeModal.close(this.sessionExpired ? false : true);
  }
}
